import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
  mounted() {
  }
})

export default class TechBetterCorpCoZaSupportPage extends Vue {
}
